module.exports = __webpack_public_path__ + "static/media/img-app-talent-profile@3x.009a23a4.png";